if (!customElements.get('sticky-buy-bar')) {
  customElements.define(
    'sticky-buy-bar',
    class StickyBuyBar extends HTMLElement {
      connectedCallback() {
        this.sectionId = this.dataset.sectionId;
        this.submitButton = document.getElementById(`ProductSubmitButton-${this.sectionId}`);
        this.button = this.querySelector('[data-sticky-buy-bar-button]');

        if (!this.submitButton || !this.button) return;

        this.submitButtonOffScreen = false;

        this.button.addEventListener('click', () => this.submitButton.click());

        this.intersectionObserver = new IntersectionObserver(([entry]) => {
          this.submitButtonOffScreen = !entry.isIntersecting;
          this.render();
        });
        this.intersectionObserver.observe(this.submitButton);

        // toggleSubmitButton() est le seul signal émis sur les deux chemins
        // d'indisponibilité : variante épuisée et combinaison inexistante.
        this.mutationObserver = new MutationObserver(() => this.render());
        this.mutationObserver.observe(this.submitButton, {
          attributes: true,
          attributeFilter: ['disabled'],
        });

        this.render();
      }

      disconnectedCallback() {
        this.intersectionObserver?.disconnect();
        this.mutationObserver?.disconnect();
      }

      get purchasable() {
        return !this.submitButton.hasAttribute('disabled');
      }

      render() {
        const visible = this.submitButtonOffScreen && this.purchasable;
        this.classList.toggle('sticky-buy-bar--visible', visible);
        this.setAttribute('aria-hidden', visible ? 'false' : 'true');
        this.button.tabIndex = visible ? 0 : -1;
      }
    }
  );
}
